export enum AvatarSize {
  Small = 'small',
  Medium = 'medium',
  Big = 'big',
}
